// extracted by mini-css-extract-plugin
export default {"btnOps":"ButtonOps_btnOps__451+d","svg":"ButtonOps_svg__X0tl8"};